export interface Bonus {
  id: string
  title: string
  value: string
  desc: string
  benefit: string
}

export const bonuses: Bonus[] = [
  {
    id: '01',
    title: 'Boxing Drill Vault: 150 Coach-Ready Drills',
    value: '20',
    desc: 'Stance, punches, combinations, footwork, defense, counters, pads, partner work, bags, reaction, conditioning and tactics. Every drill includes objective, setup, execution, cues, errors, correction, regression, progression and success criteria.',
    benefit: 'Open the vault. Choose the objective. Coach.',
  },
  {
    id: '02',
    title: '50 Boxing Games, Challenges & Competitive Drills',
    value: '16',
    desc: 'Accuracy challenges, reaction games, footwork challenges, range-control competitions, defensive response games, partner challenges, bag-work scoring rounds and tactical games.',
    benefit: 'More engagement. Same coaching standard.',
  },
  {
    id: '03',
    title: 'Boxing Mistakes & Corrections Encyclopedia: 100 Common Errors',
    value: '18',
    desc: 'Each entry follows What You See → Why It Happens → Cue → Corrective Drill → Regression → Retest — from stance and guard to tactics and ringcraft.',
    benefit: 'See the problem. Find the cause. Correct it.',
  },
  {
    id: '04',
    title: 'Kids, Teens & Adults Boxing Coaching Adaptation Guide',
    value: '16',
    desc: 'Adapt the same objectives by age, level, experience and context: coaching language, drill duration, complexity, work/rest, partner role, decision load, conditioning and safety.',
    benefit: 'Same boxing skills. The right coaching approach.',
  },
  {
    id: '05',
    title: '30 Emergency & No-Prep Boxing Sessions',
    value: '16',
    desc: 'No-prep, limited-equipment, no-bag, no-pad and solo sessions, plus mixed-level groups, short sessions, technical reset days, defense, footwork and tactical sessions.',
    benefit: 'When planning fails, your session does not have to.',
  },
]

export const bonusesTotalValue = '$86'
